import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

import { tokens } from "@olist/design-system-tokens";

export const GlobalStyle = createGlobalStyle`
  ${reset}

  html { scroll-behavior: smooth; }

  body {
    font-family:  ${tokens.fontFamily.soleil};
    line-height: 1.5;
    height: 100%;
  }

  b { font-weight: bold; }

  button { font-family:  ${tokens.fontFamily.soleil}; }
`;
